export const INFORMATION_CONSTANT = {
    // テーブル名
    TABLE: 'information',
    CSV_FILENAME: 'お知らせ一覧'
  };
  